import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.AVOD_DP_redeem_gift_card_or_promotion]:
    'Redeem a gift card or promotion code'
}
